module.exports = {"yytx23":{"daobanList":[{"title":"1:房屋租赁登记备案","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、注销房屋租赁合同登记备案申请表","state":"必要"},{"name":"2、当事人身份证明","state":"必要"},{"name":"3、授权委托书","state":"非必要"},{"name":"4、解除租赁合同协议书或已解除租赁合同的有效证明材料","state":"必要"},{"name":"5、房屋租赁凭证","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/yytx23.json
// module id = 1321
// module chunks = 0